import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=7101a16e"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports